<template>
  <modal-box class="modal-connect-wallet" :title="'Connect to Wallet'">
    <template #body>
      <ul class="connect-list">
        <li class="connect-item">
          <a
            href="#"
            @click.prevent="connectWithMetamask"
            class="connect-link --metamask"
            >Metamask</a
          >
        </li>
        <li class="connect-item">
          <a
            href="#"
            @click.prevent="connectWithWalletConnect"
            class="connect-link --walletconnect"
            >Wallet Connect</a
          >
        </li>
      </ul>
    </template>

    <template #footer>
      <text-link class="about-link" href="https://metamask.io/download.html"
        >https://metamask.io/download.html</text-link
      >
      <p class="about">
        If you are using a mobile device, please access using Metamask app
        browser.
      </p>
    </template>
  </modal-box>
</template>

<script>
import TextLink from "@/components/atoms/TextLink";
import ModalBox from "@/components/molecules/ModalBox";
import { getAccountData } from "@/utils/staking";
import { WALLET_CONNECT, METAMASK } from "@/utils/constants";
import Web3 from "web3";
import WalletConnectProvider from "@walletconnect/web3-provider";
import stakingNetwork from "@/domain/staking/network";
import cakeLpFarmingNetwork from "@/domain/cakeLpFarming/network";
import limitedStakingNetwork from "@/domain/limitedStaking/network";
import limitedCakeLpFarmingNetwork from "@/domain/limitedCakeLpFarming/network";
import limitedSaunaStakingNetwork from "@/domain/limitedSaunaStaking/network";
import limitedSaunaCakeLpFarmingNetwork from "@/domain/limitedSaunaCakeLpFarming/network";
import boilerRoomNetwork from "@/domain/boilerRoom/network";
import limitedBoilerCakeLpFarmingNetwork from "@/domain/limitedBoilerCakeLpFarming/network";
import boilerCakeLpFarmingNetwork from "@/domain/boilerCakeLpFarming/network";
import stakingToken from "@/domain/staking/token";
import cakeLpFarmingToken from "@/domain/cakeLpFarming/token";
import limitedStakingToken from "@/domain/limitedStaking/token";
import limitedCakeLpFarmingToken from "@/domain/limitedCakeLpFarming/token";
import limitedSaunaStakingToken from "@/domain/limitedSaunaStaking/token";
import limitedSaunaCakeLpFarmingToken from "@/domain/limitedSaunaCakeLpFarming/token";
import boilerRoomToken from "@/domain/boilerRoom/token";
import limitedBoilerCakeLpFarmingToken from "@/domain/limitedBoilerCakeLpFarming/token";
import boilerCakeLpFarmingToken from "@/domain/boilerCakeLpFarming/token";

export default {
  name: "ModalConnectWallet",
  components: {
    TextLink,
    ModalBox,
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
    web3() {
      return this.$store.state.web3;
    },
  },
  methods: {
    async connectWithWalletConnect() {
      const provider = new WalletConnectProvider(
        this.getNetwork(this.$route.name)
      );

      try {
        await provider.enable();
      } catch (e) {
        window.location.reload();
      }

      const instance = new Web3(provider);
      const chainId = await instance.eth.net.getId();
      sessionStorage.setItem("provider", WALLET_CONNECT);

      this.$store.dispatch("web3/update", {
        instance,
        chainId,
        provider: WALLET_CONNECT,
      });

      const token = this.getToken(this.$route.name);
      const accountData = await getAccountData(this.web3.instance, token);

      if (accountData) {
        sessionStorage.setItem("address", accountData.address);

        window.location.reload();
      } else {
        this.$store.dispatch("toast/updateToast", {
          type: "error",
          title: "Account Connect Failed",
          message: "Please check the network!",
        });
      }
    },
    async connectWithMetamask() {
      try {
        if (!window.ethereum) {
          return;
        }

        const instance = new Web3(Web3.givenProvider);
        const chainId = await instance.eth.net.getId();
        sessionStorage.setItem("provider", METAMASK);

        this.$store.dispatch("web3/update", {
          instance,
          chainId,
          provider: METAMASK,
        });

        const token = this.getToken(this.$route.name);

        let accountData = await getAccountData(this.web3.instance, token);

        if (accountData) {
          sessionStorage.setItem("address", accountData.address);
          window.location.reload();
        } else {
          this.$store.dispatch("toast/updateToast", {
            type: "error",
            title: "Connect Failed",
            message: "Please check the network!",
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    getNetwork(routeName) {
      switch (routeName) {
        case "staking":
          return {
            chainId: stakingNetwork.chainIds[0],
            rpc: {
              [stakingNetwork.chainIds[0]]: stakingNetwork.rpcUrls[0],
            },
          };

        case "cakelp-farming":
          return {
            chainId: cakeLpFarmingNetwork.chainIds[0],
            rpc: {
              [cakeLpFarmingNetwork.chainIds[0]]:
                cakeLpFarmingNetwork.rpcUrls[0],
            },
          };

        case "steam-staking":
          return {
            chainId: limitedStakingNetwork.chainIds[0],
            rpc: {
              [limitedStakingNetwork.chainIds[0]]:
                limitedStakingNetwork.rpcUrls[0],
            },
          };

        case "steam-cakelp-farming":
          return {
            chainId: limitedCakeLpFarmingNetwork.chainIds[0],
            rpc: {
              [limitedCakeLpFarmingNetwork.chainIds[0]]:
                limitedCakeLpFarmingNetwork.rpcUrls[0],
            },
          };

        case "limited-sauna-staking":
          return {
            chainId: limitedSaunaStakingNetwork.chainIds[0],
            rpc: {
              [limitedSaunaStakingNetwork.chainIds[0]]:
                limitedSaunaStakingNetwork.rpcUrls[0],
            },
          };

        case "limited-sauna-cakelp-farming":
          return {
            chainId: limitedSaunaCakeLpFarmingNetwork.chainIds[0],
            rpc: {
              [limitedSaunaCakeLpFarmingNetwork.chainIds[0]]:
                limitedSaunaCakeLpFarmingNetwork.rpcUrls[0],
            },
          };

        case "boiler-room":
          return {
            chainId: boilerRoomNetwork.chainIds[0],
            rpc: {
              [boilerRoomNetwork.chainIds[0]]: boilerRoomNetwork.rpcUrls[0],
            },
          };

        case "limited-boiler-cakelp-farming":
          return {
            chainId: limitedBoilerCakeLpFarmingNetwork.chainIds[0],
            rpc: {
              [limitedBoilerCakeLpFarmingNetwork.chainIds[0]]:
                limitedBoilerCakeLpFarmingNetwork.rpcUrls[0],
            },
          };

        case "boiler-cakelp-farming":
          return {
            chainId: boilerCakeLpFarmingNetwork.chainIds[0],
            rpc: {
              [boilerCakeLpFarmingNetwork.chainIds[0]]:
                boilerCakeLpFarmingNetwork.rpcUrls[0],
            },
          };

        default:
          return {
            chainId: stakingNetwork.chainIds[0],
            rpc: {
              [stakingNetwork.chainIds[0]]: stakingNetwork.rpcUrls[0],
            },
          };
      }
    },
    getToken(routeName) {
      switch (routeName) {
        case "staking":
          return stakingToken;

        case "cakelp-farming":
          return cakeLpFarmingToken;

        case "steam-staking":
          return limitedStakingToken;

        case "steam-cakelp-farming":
          return limitedCakeLpFarmingToken;

        case "limited-sauna-staking":
          return limitedSaunaStakingToken;

        case "limited-sauna-cakelp-farming":
          return limitedSaunaCakeLpFarmingToken;

        case "boiler-room":
          return boilerRoomToken;

        case "limited-boiler-cakelp-farming":
          return limitedBoilerCakeLpFarmingToken;

        case "boiler-cakelp-farming":
          return boilerCakeLpFarmingToken;

        default:
          return stakingToken;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.modal-connect-wallet {
  /deep/ .footer {
    @include media(pc) {
      display: none;
    }
  }
}
.connect-list {
}
.connect-item {
  &:not(:last-child) {
    margin-bottom: 8px;
  }
}
.connect-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 72px;
  padding: 0 18px;
  line-height: 70px;
  border: 1px solid $color-border;
  border-radius: 4px;
  background: var(--color_bg_parts);
  font-weight: 700;
  color: var(--color_font_parts);

  @include media(pc) {
    font-size: 1.6rem;
  }
  @include media(sp) {
    font-size: 1.2rem;
  }
  &::after {
    content: "";
    width: 40px;
    height: 40px;
    background: red;
  }
  &:hover {
    text-decoration: none;
  }

  $wallets: metamask, trustwallet, mathwallet, tokenpocket, mathwallet, sfp,
    walletconnect;

  @each $wallet in $wallets {
    &.--#{$wallet}::after {
      background: url(/assets/sf/icon/wallet-#{$wallet}.svg);
    }
  }
}
.about-link {
  font-size: 1.4rem;
}
.about {
  font-size: 1.2rem;
}
</style>